/**
 * Popup Modal Service
 *
 * DO NOT CUSTOMIZE!!!
 *
 * - If you need custom features, use popup-site-ui-kit.component as a template
 *
 * - Reviewers: Do not approve any change specific only for a unique modal
 */
import { Injectable, Output, EventEmitter, Directive } from "@angular/core";

@Directive()
@Injectable()
export class PopupModalService {

  /** 
   * Only one modal and one tooltip can be open at one time
   * Tooltip always goes over modal
   * Buttons and links on modals can close modal and then go to another modal
   * Buttons and links on tooltips can open a tooltip on top the modal
   * 
   * TBD: Future stack logic goes here, refactor z-index depth logic
   */
  // Common functions used by all popup modals
    @Output() openPopupModal = new EventEmitter<any>();
    @Output() closePopupModal = new EventEmitter<any>();

    @Output() openPopupContent = new EventEmitter<any>();
    @Output() closePopupContent = new EventEmitter<any>();
    @Output() dismissablePopupContent = new EventEmitter<any>();
    @Output() notDismissablePopupContent = new EventEmitter<any>();

    @Output() openMfaModalLibrary = new EventEmitter<any>();
    @Output() closeMfaModalLibrary = new EventEmitter<any>();

    @Output() setTriggerElement = new EventEmitter<any>();
    @Output() setElementStyle = new EventEmitter<any>();

    // Scroll view Popup opened or closed  (Common function)
    scrollView(isOpen :boolean) {
      var body =  document.querySelector('body');
      if(isOpen){
        body.style.overflow = "hidden";
      }else {
        body.style.overflow = "auto";
      }
    }

}

